import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import $ from "jquery";
import { Channels, IChannel } from "@/ts/common-types";
import { useSelector } from "react-redux";

type LayoutProps = {
    heading: string | React.ReactNode;
    children: React.ReactNode;
    cardId?: string;
    display?: string;
};

const CardsLayout = (props: LayoutProps) => {
    const [cardClasses, setCardClasses] = useState<string>("card-body");
    const channel = useSelector((state: IChannel) => state.channel.value);

    useEffect(() => {
        if (props.cardId === "popover-card") {
            setCardClasses("card-body bg-white");
        }
    }, [props.cardId]);

    return (
        <>
            <div
                className="col"
                id={props.cardId}
                style={{ display: props.display ? props.display : "unset" }}
            >
                <div className="card bg-light">
                    <div className="card-header">
                        {props.heading}
                        {props.cardId === "get-campaigns" &&
                            $("#add-negative-keyword-btn").hasClass(
                                "btn-danger selected"
                            ) &&
                            channel === Channels.BLINKIT && (
                                <Tooltip title="Negative keyword targeting is only applicable for those campaigns where smart bid is enabled on a keyword">
                                <FaInfoCircle
                                        style={{
                                        margin: "0 0 3px 5px"
                                        }}
                                    />
                                </Tooltip>
                            )}
                    </div>
                    <div className={cardClasses}>{props.children}</div>
                </div>
            </div>
        </>
    );
};

export default CardsLayout;
